import {
    memo,
    useEffect
} from 'react'
import { useDashboard } from '@app/layouts/dashboard/Provider'
import { usePermission } from '@shared/hooks/permissions'

import List from './parts/List'
import Refresh from './parts/Refresh'
import Add from './parts/Add'

export default memo(function Users() {
    const { setTitle } = useDashboard()
    const { hasPermission } = usePermission()

    useEffect(() => {
        setTitle('المستخدمين')
    }, [])

    return (
        <>
            <List />
            <Refresh />
            {hasPermission('add_user') && <Add />}
        </>
    )
})
